import { Info } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

/**
 * Wraps a dashboard/diagram block; hover shows where the agent found the underlying fact.
 */
export default function AuraSourceTooltip({
  source,
  title = 'Source',
  children,
  className = '',
  showHintIcon = false,
  contentClassName = '',
}) {
  if (!source || !String(source).trim()) {
    return children;
  }

  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        <div
          className={`group relative cursor-help ${className}`}
          data-source-tooltip
        >
          {children}
          {showHintIcon ? (
            <span className="pointer-events-none absolute right-2 top-2 opacity-0 transition-opacity group-hover:opacity-60">
              <Info className="h-3 w-3 text-muted-foreground" aria-hidden />
            </span>
          ) : null}
        </div>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        align="center"
        sideOffset={6}
        collisionPadding={12}
        className={`z-[60] max-w-xs border bg-popover p-3 text-left text-popover-foreground shadow-md ${contentClassName}`}
      >
        <p className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
          {title}
        </p>
        <p className="mt-1 whitespace-pre-wrap text-xs leading-relaxed text-foreground">{source}</p>
      </TooltipContent>
    </Tooltip>
  );
}
